import '@fontsource/pt-sans-narrow/latin-400.css';
import '@fontsource/pt-sans-narrow/latin-700.css';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import './src/sass/main.scss';
import React from 'react';
import RootLayout from './src/pages/layouts/root.layout';
import { GatsbyBrowser } from 'gatsby';

// wrapPageElement, not wrapRootElement: Gatsby also wraps <head> content in wrapRootElement,
// which would render the footer into the head
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => {
  return <RootLayout>{element}</RootLayout>;
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ prevLocation }) => {
  if (prevLocation) {
    window.fbq?.('track', 'PageView');
  }
};

// Updates DOM to indicate app has been hydrated
export const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  document.documentElement.dataset.hydrated = 'true';
};
